import { useEffect } from "react";
export const description =
  "Quantingo designs and builds complex production software across embedded systems, IoT, AI, backend platforms and Android applications, combining senior architecture with hands-on engineering.";
export function useMetadata(title, path, summary = description) {
  useEffect(() => {
    document.title = title;
    const values = {
      'meta[name="description"]': summary,
      'meta[property="og:title"]': title,
      'meta[property="og:description"]': summary,
      'meta[property="og:url"]': `https://quantingo.com${path || "/"}`,
      'meta[name="twitter:title"]': title,
      'meta[name="twitter:description"]': summary,
      'meta[name="robots"]': path ? "index, follow" : "noindex, follow",
    };
    Object.entries(values).forEach(([selector, value]) =>
      document.querySelector(selector)?.setAttribute("content", value),
    );
    document
      .querySelector('link[rel="canonical"]')
      ?.setAttribute("href", `https://quantingo.com${path || "/"}`);
  }, [title, path, summary]);
}
